import { useEffect, useState } from "react";

let _cache = null;
let _promise = null;

function fetchSettings() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/site-config`)
      .then((r) => r.json())
      .then((d) => { _cache = d.settings || {}; return _cache; })
      .catch(() => ({}));
  }
  return _promise;
}

export function useSiteSettings() {
  const [settings, setSettings] = useState(_cache || {});
  useEffect(() => {
    let on = true;
    fetchSettings().then((s) => { if (on) setSettings(s); });
    return () => { on = false; };
  }, []);
  return settings;
}
